import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Expense  {
    _originalTypeClassName = "zPMO.BO.Expense";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Expense.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Amount = null;
this.Date = null;
this.Comment = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Amount:any;
Date:any;
Comment:any;
ExpenseRule:any;
FiscalYear:any;
Category:any;
Company:any;
static setExpenseRule = ($this, value) => {
var oldValue = $this.ExpenseRule;
$this.ExpenseRule = value;
if (value != null) {
}
}
static setFiscalYear = ($this, value) => {
var oldValue = $this.FiscalYear;
$this.FiscalYear = value;
if (value != null) {
}
}
static setCategory = ($this, value) => {
var oldValue = $this.Category;
$this.Category = value;
if (value != null) {
}
}
static setCompany = ($this, value) => {
var oldValue = $this.Company;
$this.Company = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}